import React from "react";
import { useAtom } from "jotai";
import { darkModeAtom } from "../jotai/atoms";
import { WHITELABEL_KEY } from "../globals";

// Simple wrapper component to pull in dark mode from Jotai state
// and apply the correct daisyui theme to the root element of the app.
export default function ThemeWrapper({ children }: { children: React.ReactNode }) {
  const [darkMode] = useAtom(darkModeAtom);

  return (
    <div
      {...(WHITELABEL_KEY === "nj"
        ? // Only one theme for NJ... It doesn't have a dark mode
          { "data-theme": "docket-nj" }
        : darkMode
        ? { "data-theme": "docket-dark" }
        : { "data-theme": "docket" })}
      className="h-full max-md:bg-secondary md:bg-linear-to-b from-neutral to-secondary max-md:has-[.override-bg-to-neutral]:bg-neutral has-[.override-bg-use-gradient]:bg-linear-to-b pt-[env(safe-area-inset-top)] jersey:from-info jersey:to-info"
    >
      {children}
    </div>
  );
}
